module.exports = __webpack_public_path__ + "sidewalk.jpg?2434a15afb34350b8d11ccbdaf7551f2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sidewalk.jpg
// module id = 26
// module chunks = 0